import { createI18n } from "vue-i18n";

// Import translation files
import en from "./locales/en.json";
import es from "./locales/es.json";

// Define the i18n instance
const i18n = createI18n({
	locale: "en", // Default locale
	fallbackLocale: "en", // Fallback if a key is missing
	messages: {
		en,
		es
	}
});
// active i18n locale is assigned in multiple places depending on login workflow
// in non-vue files via `i18n.global.locale`, and in vue components by `i18n.locale`
export default i18n;
